import { Const_ChiefComplaint, Const_DifferentialDiagnosis, Const_OrderSet, Const_Treatment, Const_Triage, pathwayType_SingleState } from '@app/pathway-shared';
import { PathwayStatus } from '../runtime-protocol/index.js';
export const canBeSeenByPhysician = (pathwayType) => {
    return [Const_DifferentialDiagnosis, Const_Treatment, Const_ChiefComplaint, pathwayType_SingleState, Const_OrderSet].includes(pathwayType);
};
export const canBeSeenByNurse = (pathwayType) => {
    return [Const_Triage].includes(pathwayType);
};
export const isProtocolEnded = (protocol) => [PathwayStatus.REACHED_REASSESSMENT,
    PathwayStatus.REACHED_CC_PROTOCOL_END,
    PathwayStatus.REACHED_OS_PROTOCOL_END].includes(protocol.status);
//# sourceMappingURL=consts.js.map